import { useStickyTypeStore } from "@/store/stickyType";

import { BaseBacklogBoard } from "./BaseBacklogBoard";

export class SolutionBacklogBoard extends BaseBacklogBoard<"solution_backlog"> {
  get possibleStickyTypes() {
    return useStickyTypeStore().nonFlexBoardStickyTypes("solution_backlog");
  }
}
